export const JackpotTypes = {
  Mega: 1,
  Betshop: 2,
  Game: 3,
}

export const JackpotTypeNames = {
  Mega: "mega",
  Betshop: "betshop",
  Game: "game",
}